import { css } from '@emotion/core'
import { screenSmall } from 'components/utils/screen-sizes'
import { PAYPAL_THEME } from '@paypalcorp/pp-react-theme'

const { sysColorBackgroundMediumContrast } = PAYPAL_THEME

export const autoMarginBottomCss = css`
  margin: 0 auto 1.5rem;
  text-align: center;
  justify-self: center;
`

export const modalPageCss = css`
  @media (max-width: ${screenSmall}) {
    height: 100%;
    max-width: 100%;
    display: flex;
    flex-direction: column;
  }

  .subtitle {
    color: ${sysColorBackgroundMediumContrast};
  }

  .align-center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`

export const blackButtonCss = css`
  background-color: #000000 !important;
  border-color: #000000 !important;
  color: #ffffff !important;
  width: 300px !important;
  margin: 32px auto 0 auto !important;

  &:disabled {
    cursor: not-allowed;
    pointer-events: none;
  }

  &:focus {
    outline: 2px solid #000000;
    outline-offset: 2px;
  }
`

// Full height page styling that extends modalPageCss
export const fullHeightPageCss = css`
  ${modalPageCss}
  ${'' /* min-height: 100vh;
  height: 100%; */}
`

// White background container with full height for flows
export const flowContainerCss = css`
  background-color: white;
  min-height: 100vh;
  height: 100%;
`